import variables from '../variables'

import type { SelectOverrideToken } from './types'

const Select: SelectOverrideToken = {
  colorTextPlaceholder: variables.gray40
} as const

export default Select
